import { Component} from '@angular/core';

@Component({
    selector: 'assistance-main',
    templateUrl: './assistance-main.tmpl.html'
})

export class AssistanceMain {
    editMode: boolean = null;

    public setVal(val:boolean) {
        this.editMode = val;
    }
}
